export const trackEvent = (
  eventName: string,
  params?: Record<string, string>
) => {
  if (typeof window.gtag !== 'undefined') {
    console.log("gtag")
    window.gtag('event', eventName, params);
  }
};

export enum EVENT {
  BTN_COPY_LINK = 'btn_copy_shared_link',
  BTN_SHARE_CLICKED = 'btn_share_clicked',
  VISIT_SHARE_NAV_PAGE = 'visit_share_nav_page',
  NAV_PAGE_3D_INTERACTION = 'nav_page_3d_interaction',
  EXPLORE_JOYSTICK_INTERACTION = 'explore_joystick_interaction',
  EXPLORE_INTERACTION = 'explore_interaction',
}